import { render, staticRenderFns } from "./contactListsImport.vue?vue&type=template&id=27ac7ad3&"
import script from "./contactListsImport.vue?vue&type=script&lang=js&"
export * from "./contactListsImport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports